import { bootstrapModuleV2 } from 'tools/bootstrap'

import { AppModule } from './app/app.module'

bootstrapModuleV2<AppModule>(AppModule)
